import { http } from '../services';

class OuvinteService {
    ouvinteForm() {
        return http.get('/ouvintes/form');
    }

    save(ouvinte) {
        return http.post('/ouvintes', {
            ouvinte,
        });
    }

    update(ouvinte) {
        return http.put('/ouvintes', {
            ouvinte,
        });
    }

    getOuvinte(ouvinte) {
        return http.get(`/ouvintes/${ouvinte}`);
    }

    getOuvinteEstaInscrito(email, evento) {
        return http.get(
            '/ouvintes/ouvinte-esta-inscrito',
            {
                email,
                evento,
            },
        );
    }
    async getOuvintes(area, pago) {
        return http.get('/ouvintes', {
            area,
            pago,
        });
    }
}

const ouvinteService = new OuvinteService();
export default ouvinteService;
